import * as React from "react";
import styles from "./ToggleButton.module.scss";
import { cn } from "../../../helpers";

export interface ToggleButtonProps {
    checked: boolean;
    onToggle: (checked: boolean) => void;
    label: string;
    variant?: "availability" | "office-window" | "held" | "confirmed" | "intake";
    disabled?: boolean;
    className?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
    checked,
    onToggle,
    label,
    variant = "availability",
    disabled = false,
    className,
}) => {
    const handleToggle = () => {
        if (!disabled) {
            onToggle(!checked);
        }
    };

    return (
        <div className={cn(styles.toggleContainer, styles[variant], className)}>
            <button
                type="button"
                className={cn(
                    styles.toggleButton,
                    checked && styles.checked,
                    disabled && styles.disabled
                )}
                onClick={handleToggle}
                disabled={disabled}
                style={
                    {
                        "--toggle-color":
                            variant === "availability"
                                ? "#2F7DF5"
                                : variant === "office-window"
                                ? "#8B5CF6"
                                : variant === "held"
                                ? "#DDA31B"
                                : variant === "confirmed"
                                ? "#1CAE60"
                                : variant === "intake"
                                ? "#E53935"
                                : "#2F7DF5",
                    } as React.CSSProperties
                }
            >
                <div className={styles.toggleTrack}>
                    <div className={styles.toggleThumb} />
                </div>
            </button>
            <span className={styles.label}>{label}</span>
        </div>
    );
};
